/**
 * Shared Firebase Configurations
 * Single source of truth for all Firebase project configurations
 * Used by both Vue 2 and Nuxt 3 apps
 */

// Development Firebase configuration
export const devConfig = {
  apiKey: 'AIzaSyBp-YZgqrbBZryGj2BJu2YzXpVTw72clnU',
  authDomain: 'linkbook-dev-43882.firebaseapp.com',
  databaseURL: 'https://linkbook-dev-43882.firebaseio.com',
  projectId: 'linkbook-dev-43882',
  storageBucket: 'linkbook-dev-43882.firebasestorage.app',
  messagingSenderId: '435571586571',
  appId: '1:435571586571:web:d440f3fd0b52f34984790e'
}

// Production Firebase configuration
export const prodConfig = {
  apiKey: 'AIzaSyCTXyM8ASyQMZ5fi7Xswgu3Q6XxTyYcdAA',
  authDomain: 'linkbook-3e0f2.firebaseapp.com',
  databaseURL: 'https://linkbook-3e0f2.firebaseio.com',
  projectId: 'linkbook-3e0f2',
  storageBucket: 'linkbook-3e0f2.appspot.com',
  messagingSenderId: '960509031824',
  appId: '1:960509031824:web:68250a8047e65552eb6f15',
  measurementId: 'G-97585Y35S7'
}

/**
 * Get Firebase configuration based on NODE_ENV
 * @returns {Object} Firebase configuration object
 */
export function getConfigByEnv() {
  const isDevelopment = process.env.NODE_ENV === 'development'
  return isDevelopment ? devConfig : prodConfig
}
